<template>
  <div>
    <DetailIndex :userReimbursementCode="params.code" />
  </div>
</template>
<script>
import DetailIndex from './components/detail'
export default {
  components: { DetailIndex },
  name: 'opview-myReimbursement',
  computed: {
    params() {
      return this.$route.params
    },
  },
}
</script>
